// Phase 1 methods, identifiers 1 to 26.
//
// One {Method}Request and one {Method}Response per row of the Section 15
// catalog, with tag numbers assigned 1..N in the order that table lists them.
// Persisted mutations carry client_op_id as their last field. Reads and
// ephemeral methods do not have one: there is nothing to make idempotent.
//
// Byte lengths and semantic limits that Protobuf cannot express are still
// mandatory. They are enforced by the validators in internal/message and
// internal/platform, and the constants there cite this file.

// @generated by protoc-gen-es v2.14.1 with parameter "target=ts"
// @generated from file chat/v1/methods_p1.proto (package chat.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Commit, Content, Conversation, Dialog, Difference, Error, Message as Message$1, PageInfo } from "./common_pb";
import { file_chat_v1_common } from "./common_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file chat/v1/methods_p1.proto.
 */
export const file_chat_v1_methods_p1: GenFile = /*@__PURE__*/
  fileDesc("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", [file_chat_v1_common]);

/**
 * @generated from message chat.v1.HelloRequest
 */
export type HelloRequest = Message<"chat.v1.HelloRequest"> & {
  /**
   * @generated from field: uint32 major = 1;
   */
  major: number;

  /**
   * @generated from field: uint32 minor = 2;
   */
  minor: number;

  /**
   * @generated from field: repeated string capabilities = 3;
   */
  capabilities: string[];

  /**
   * @generated from field: string platform = 4;
   */
  platform: string;
};

/**
 * Describes the message chat.v1.HelloRequest.
 * Use `create(HelloRequestSchema)` to create a new message.
 */
export const HelloRequestSchema: GenMessage<HelloRequest> = /*@__PURE__*/
  messageDesc(file_chat_v1_methods_p1, 0);

/**
 * @generated from message chat.v1.HelloResponse
 */
export type HelloResponse = Message<"chat.v1.HelloResponse"> & {
  /**
   * @generated from field: uint32 major = 1;
   */
  major: number;

  /**
   * @generated from field: uint32 minor = 2;
   */
  minor: number;

  /**
   * @generated from field: repeated string capabilities = 3;
   */
  capabilities: string[];

  /**
   * @generated from field: int64 server_time = 4;
   */
  serverTime: bigint;
};

/**
 * Describes the message chat.v1.HelloResponse.
 * Use `create(HelloResponseSchema)` to create a new message.
 */
export const HelloResponseSchema: GenMessage<HelloResponse> = /*@__PURE__*/
  messageDesc(file_chat_v1_methods_p1, 1);

/**
 * @generated from message chat.v1.AuthRequest
 */
export type AuthRequest = Message<"chat.v1.AuthRequest"> & {
  /**
   * @generated from field: string connection_ticket = 1;
   */
  connectionTicket: string;
};

/**
 * Describes the message chat.v1.AuthRequest.
 * Use `create(AuthRequestSchema)` to create a new message.
 */
export const AuthRequestSchema: GenMessage<AuthRequest> = /*@__PURE__*/
  messageDesc(file_chat_v1_methods_p1, 2);

/**
 * @generated from message chat.v1.AuthResponse
 */
export type AuthResponse = Message<"chat.v1.AuthResponse"> & {
  /**
   * @generated from field: bytes user_id = 1;
   */
  userId: Uint8Array;

  /**
   * @generated from field: bytes device_id = 2;
   */
  deviceId: Uint8Array;

  /**
   * @generated from field: bytes session_id = 3;
   */
  sessionId: Uint8Array;

  /**
   * @generated from field: uint32 heartbeat_ms = 4;
   */
  heartbeatMs: number;

  /**
   * The refresh generation this connection authenticated under.
   *
   * The gateway forwards it with every command so core can answer "is this
   * session still live" from a short-lived cache instead of a database read.
   * Without it the cache can never match and every single command pays for a
   * session lookup.
   *
   * @generated from field: int64 generation = 5;
   */
  generation: bigint;
};

/**
 * Describes the message chat.v1.AuthResponse.
 * Use `create(AuthResponseSchema)` to create a new message.
 */
export const AuthResponseSchema: GenMessage<AuthResponse> = /*@__PURE__*/
  messageDesc(file_chat_v1_methods_p1, 3);

/**
 * @generated from message chat.v1.PingRequest
 */
export type PingRequest = Message<"chat.v1.PingRequest"> & {
  /**
   * @generated from field: int64 nonce = 1;
   */
  nonce: bigint;
};

/**
 * Describes the message chat.v1.PingRequest.
 * Use `create(PingRequestSchema)` to create a new message.
 */
export const PingRequestSchema: GenMessage<PingRequest> = /*@__PURE__*/
  messageDesc(file_chat_v1_methods_p1, 4);

/**
 * @generated from message chat.v1.PingResponse
 */
export type PingResponse = Message<"chat.v1.PingResponse"> & {
  /**
   * @generated from field: int64 nonce = 1;
   */
  nonce: bigint;

  /**
   * @generated from field: int64 server_time = 2;
   */
  serverTime: bigint;
};

/**
 * Describes the message chat.v1.PingResponse.
 * Use `create(PingResponseSchema)` to create a new message.
 */
export const PingResponseSchema: GenMessage<PingResponse> = /*@__PURE__*/
  messageDesc(file_chat_v1_methods_p1, 5);

/**
 * @generated from message chat.v1.CreateDirectConversationRequest
 */
export type CreateDirectConversationRequest = Message<"chat.v1.CreateDirectConversationRequest"> & {
  /**
   * @generated from field: bytes peer_id = 1;
   */
  peerId: Uint8Array;

  /**
   * @generated from field: bytes client_op_id = 2;
   */
  clientOpId: Uint8Array;
};

/**
 * Describes the message chat.v1.CreateDirectConversationRequest.
 * Use `create(CreateDirectConversationRequestSchema)` to create a new message.
 */
export const CreateDirectConversationRequestSchema: GenMessage<CreateDirectConversationRequest> = /*@__PURE__*/
  messageDesc(file_chat_v1_methods_p1, 6);

/**
 * @generated from message chat.v1.CreateDirectConversationResponse
 */
export type CreateDirectConversationResponse = Message<"chat.v1.CreateDirectConversationResponse"> & {
  /**
   * @generated from field: chat.v1.Conversation conversation = 1;
   */
  conversation?: Conversation | undefined;

  /**
   * @generated from field: chat.v1.Commit commit = 2;
   */
  commit?: Commit | undefined;
};

/**
 * Describes the message chat.v1.CreateDirectConversationResponse.
 * Use `create(CreateDirectConversationResponseSchema)` to create a new message.
 */
export const CreateDirectConversationResponseSchema: GenMessage<CreateDirectConversationResponse> = /*@__PURE__*/
  messageDesc(file_chat_v1_methods_p1, 7);

/**
 * @generated from message chat.v1.SendMessageRequest
 */
export type SendMessageRequest = Message<"chat.v1.SendMessageRequest"> & {
  /**
   * @generated from field: bytes conversation_id = 1;
   */
  conversationId: Uint8Array;

  /**
   * @generated from field: chat.v1.Content content = 2;
   */
  content?: Content | undefined;

  /**
   * @generated from field: bytes client_op_id = 3;
   */
  clientOpId: Uint8Array;
};

/**
 * Describes the message chat.v1.SendMessageRequest.
 * Use `create(SendMessageRequestSchema)` to create a new message.
 */
export const SendMessageRequestSchema: GenMessage<SendMessageRequest> = /*@__PURE__*/
  messageDesc(file_chat_v1_methods_p1, 8);

/**
 * @generated from message chat.v1.SendMessageResponse
 */
export type SendMessageResponse = Message<"chat.v1.SendMessageResponse"> & {
  /**
   * @generated from field: chat.v1.Commit commit = 1;
   */
  commit?: Commit | undefined;
};

/**
 * Describes the message chat.v1.SendMessageResponse.
 * Use `create(SendMessageResponseSchema)` to create a new message.
 */
export const SendMessageResponseSchema: GenMessage<SendMessageResponse> = /*@__PURE__*/
  messageDesc(file_chat_v1_methods_p1, 9);

/**
 * @generated from message chat.v1.GetOperationStatusRequest
 */
export type GetOperationStatusRequest = Message<"chat.v1.GetOperationStatusRequest"> & {
  /**
   * @generated from field: optional bytes conversation_id = 1;
   */
  conversationId?: Uint8Array | undefined;

  /**
   * @generated from field: bytes operation_id = 2;
   */
  operationId: Uint8Array;
};

/**
 * Describes the message chat.v1.GetOperationStatusRequest.
 * Use `create(GetOperationStatusRequestSchema)` to create a new message.
 */
export const GetOperationStatusRequestSchema: GenMessage<GetOperationStatusRequest> = /*@__PURE__*/
  messageDesc(file_chat_v1_methods_p1, 10);

/**
 * @generated from message chat.v1.GetOperationStatusResponse
 */
export type GetOperationStatusResponse = Message<"chat.v1.GetOperationStatusResponse"> & {
  /**
   * @generated from field: chat.v1.GetOperationStatusResponse.Status status = 1;
   */
  status: GetOperationStatusResponse_Status;

  /**
   * @generated from field: optional chat.v1.Commit commit = 2;
   */
  commit?: Commit | undefined;

  /**
   * @generated from field: optional chat.v1.Error error = 3;
   */
  error?: Error | undefined;
};

/**
 * Describes the message chat.v1.GetOperationStatusResponse.
 * Use `create(GetOperationStatusResponseSchema)` to create a new message.
 */
export const GetOperationStatusResponseSchema: GenMessage<GetOperationStatusResponse> = /*@__PURE__*/
  messageDesc(file_chat_v1_methods_p1, 11);

/**
 * @generated from enum chat.v1.GetOperationStatusResponse.Status
 */
export enum GetOperationStatusResponse_Status {
  /**
   * @generated from enum value: STATUS_UNKNOWN = 0;
   */
  UNKNOWN = 0,

  /**
   * @generated from enum value: STATUS_COMMITTED = 1;
   */
  COMMITTED = 1,

  /**
   * @generated from enum value: STATUS_REJECTED = 2;
   */
  REJECTED = 2,
}

/**
 * Describes the enum chat.v1.GetOperationStatusResponse.Status.
 */
export const GetOperationStatusResponse_StatusSchema: GenEnum<GetOperationStatusResponse_Status> = /*@__PURE__*/
  enumDesc(file_chat_v1_methods_p1, 11, 0);

/**
 * @generated from message chat.v1.EditMessageRequest
 */
export type EditMessageRequest = Message<"chat.v1.EditMessageRequest"> & {
  /**
   * @generated from field: bytes conversation_id = 1;
   */
  conversationId: Uint8Array;

  /**
   * @generated from field: bytes message_id = 2;
   */
  messageId: Uint8Array;

  /**
   * @generated from field: int64 expected_version = 3;
   */
  expectedVersion: bigint;

  /**
   * @generated from field: chat.v1.Content content = 4;
   */
  content?: Content | undefined;

  /**
   * @generated from field: bytes client_op_id = 5;
   */
  clientOpId: Uint8Array;
};

/**
 * Describes the message chat.v1.EditMessageRequest.
 * Use `create(EditMessageRequestSchema)` to create a new message.
 */
export const EditMessageRequestSchema: GenMessage<EditMessageRequest> = /*@__PURE__*/
  messageDesc(file_chat_v1_methods_p1, 12);

/**
 * @generated from message chat.v1.EditMessageResponse
 */
export type EditMessageResponse = Message<"chat.v1.EditMessageResponse"> & {
  /**
   * @generated from field: chat.v1.Commit commit = 1;
   */
  commit?: Commit | undefined;
};

/**
 * Describes the message chat.v1.EditMessageResponse.
 * Use `create(EditMessageResponseSchema)` to create a new message.
 */
export const EditMessageResponseSchema: GenMessage<EditMessageResponse> = /*@__PURE__*/
  messageDesc(file_chat_v1_methods_p1, 13);

/**
 * @generated from message chat.v1.DeleteMessageRequest
 */
export type DeleteMessageRequest = Message<"chat.v1.DeleteMessageRequest"> & {
  /**
   * @generated from field: bytes conversation_id = 1;
   */
  conversationId: Uint8Array;

  /**
   * @generated from field: bytes message_id = 2;
   */
  messageId: Uint8Array;

  /**
   * @generated from field: chat.v1.DeleteMessageRequest.Scope scope = 3;
   */
  scope: DeleteMessageRequest_Scope;

  /**
   * @generated from field: int64 expected_version = 4;
   */
  expectedVersion: bigint;

  /**
   * @generated from field: bytes client_op_id = 5;
   */
  clientOpId: Uint8Array;
};

/**
 * Describes the message chat.v1.DeleteMessageRequest.
 * Use `create(DeleteMessageRequestSchema)` to create a new message.
 */
export const DeleteMessageRequestSchema: GenMessage<DeleteMessageRequest> = /*@__PURE__*/
  messageDesc(file_chat_v1_methods_p1, 14);

/**
 * @generated from enum chat.v1.DeleteMessageRequest.Scope
 */
export enum DeleteMessageRequest_Scope {
  /**
   * @generated from enum value: SCOPE_UNKNOWN = 0;
   */
  UNKNOWN = 0,

  /**
   * @generated from enum value: SCOPE_SELF = 1;
   */
  SELF = 1,

  /**
   * @generated from enum value: SCOPE_EVERYONE = 2;
   */
  EVERYONE = 2,
}

/**
 * Describes the enum chat.v1.DeleteMessageRequest.Scope.
 */
export const DeleteMessageRequest_ScopeSchema: GenEnum<DeleteMessageRequest_Scope> = /*@__PURE__*/
  enumDesc(file_chat_v1_methods_p1, 14, 0);

/**
 * @generated from message chat.v1.DeleteMessageResponse
 */
export type DeleteMessageResponse = Message<"chat.v1.DeleteMessageResponse"> & {
  /**
   * @generated from field: chat.v1.Commit commit = 1;
   */
  commit?: Commit | undefined;
};

/**
 * Describes the message chat.v1.DeleteMessageResponse.
 * Use `create(DeleteMessageResponseSchema)` to create a new message.
 */
export const DeleteMessageResponseSchema: GenMessage<DeleteMessageResponse> = /*@__PURE__*/
  messageDesc(file_chat_v1_methods_p1, 15);

/**
 * @generated from message chat.v1.GetHistoryRequest
 */
export type GetHistoryRequest = Message<"chat.v1.GetHistoryRequest"> & {
  /**
   * @generated from field: bytes conversation_id = 1;
   */
  conversationId: Uint8Array;

  /**
   * @generated from field: optional bytes cursor = 2;
   */
  cursor?: Uint8Array | undefined;

  /**
   * @generated from field: chat.v1.GetHistoryRequest.Direction direction = 3;
   */
  direction: GetHistoryRequest_Direction;

  /**
   * @generated from field: uint32 limit = 4;
   */
  limit: number;

  /**
   * @generated from field: uint32 byte_limit = 5;
   */
  byteLimit: number;

  /**
   * @generated from field: optional int64 min_seq = 6;
   */
  minSeq?: bigint | undefined;
};

/**
 * Describes the message chat.v1.GetHistoryRequest.
 * Use `create(GetHistoryRequestSchema)` to create a new message.
 */
export const GetHistoryRequestSchema: GenMessage<GetHistoryRequest> = /*@__PURE__*/
  messageDesc(file_chat_v1_methods_p1, 16);

/**
 * @generated from enum chat.v1.GetHistoryRequest.Direction
 */
export enum GetHistoryRequest_Direction {
  /**
   * @generated from enum value: DIRECTION_UNKNOWN = 0;
   */
  UNKNOWN = 0,

  /**
   * @generated from enum value: DIRECTION_BEFORE = 1;
   */
  BEFORE = 1,

  /**
   * @generated from enum value: DIRECTION_AFTER = 2;
   */
  AFTER = 2,
}

/**
 * Describes the enum chat.v1.GetHistoryRequest.Direction.
 */
export const GetHistoryRequest_DirectionSchema: GenEnum<GetHistoryRequest_Direction> = /*@__PURE__*/
  enumDesc(file_chat_v1_methods_p1, 16, 0);

/**
 * @generated from message chat.v1.GetHistoryResponse
 */
export type GetHistoryResponse = Message<"chat.v1.GetHistoryResponse"> & {
  /**
   * @generated from field: repeated chat.v1.Message messages = 1;
   */
  messages: Message$1[];

  /**
   * @generated from field: chat.v1.PageInfo page = 2;
   */
  page?: PageInfo | undefined;

  /**
   * The sequence through which this response reflects applied state, so a
   * client can tell a genuinely empty range from one it has not caught up to.
   *
   * @generated from field: int64 applied_watermark = 3;
   */
  appliedWatermark: bigint;
};

/**
 * Describes the message chat.v1.GetHistoryResponse.
 * Use `create(GetHistoryResponseSchema)` to create a new message.
 */
export const GetHistoryResponseSchema: GenMessage<GetHistoryResponse> = /*@__PURE__*/
  messageDesc(file_chat_v1_methods_p1, 17);

/**
 * @generated from message chat.v1.GetDifferenceRequest
 */
export type GetDifferenceRequest = Message<"chat.v1.GetDifferenceRequest"> & {
  /**
   * @generated from field: bytes conversation_id = 1;
   */
  conversationId: Uint8Array;

  /**
   * @generated from field: optional bytes cursor = 2;
   */
  cursor?: Uint8Array | undefined;

  /**
   * @generated from field: uint32 byte_limit = 3;
   */
  byteLimit: number;
};

/**
 * Describes the message chat.v1.GetDifferenceRequest.
 * Use `create(GetDifferenceRequestSchema)` to create a new message.
 */
export const GetDifferenceRequestSchema: GenMessage<GetDifferenceRequest> = /*@__PURE__*/
  messageDesc(file_chat_v1_methods_p1, 18);

/**
 * @generated from message chat.v1.GetDifferenceResponse
 */
export type GetDifferenceResponse = Message<"chat.v1.GetDifferenceResponse"> & {
  /**
   * @generated from field: chat.v1.Difference difference = 1;
   */
  difference?: Difference | undefined;
};

/**
 * Describes the message chat.v1.GetDifferenceResponse.
 * Use `create(GetDifferenceResponseSchema)` to create a new message.
 */
export const GetDifferenceResponseSchema: GenMessage<GetDifferenceResponse> = /*@__PURE__*/
  messageDesc(file_chat_v1_methods_p1, 19);

/**
 * @generated from message chat.v1.SyncUserRequest
 */
export type SyncUserRequest = Message<"chat.v1.SyncUserRequest"> & {
  /**
   * @generated from field: optional bytes cursor = 1;
   */
  cursor?: Uint8Array | undefined;

  /**
   * @generated from field: optional bytes snapshot_id = 2;
   */
  snapshotId?: Uint8Array | undefined;

  /**
   * @generated from field: uint32 byte_limit = 3;
   */
  byteLimit: number;
};

/**
 * Describes the message chat.v1.SyncUserRequest.
 * Use `create(SyncUserRequestSchema)` to create a new message.
 */
export const SyncUserRequestSchema: GenMessage<SyncUserRequest> = /*@__PURE__*/
  messageDesc(file_chat_v1_methods_p1, 20);

/**
 * @generated from message chat.v1.SyncUserResponse
 */
export type SyncUserResponse = Message<"chat.v1.SyncUserResponse"> & {
  /**
   * @generated from field: chat.v1.Difference difference = 1;
   */
  difference?: Difference | undefined;

  /**
   * @generated from field: optional bytes snapshot_id = 2;
   */
  snapshotId?: Uint8Array | undefined;

  /**
   * @generated from field: optional int64 snapshot_fence = 3;
   */
  snapshotFence?: bigint | undefined;
};

/**
 * Describes the message chat.v1.SyncUserResponse.
 * Use `create(SyncUserResponseSchema)` to create a new message.
 */
export const SyncUserResponseSchema: GenMessage<SyncUserResponse> = /*@__PURE__*/
  messageDesc(file_chat_v1_methods_p1, 21);

/**
 * @generated from message chat.v1.ListDialogHeadsRequest
 */
export type ListDialogHeadsRequest = Message<"chat.v1.ListDialogHeadsRequest"> & {
  /**
   * @generated from field: optional bytes cursor = 1;
   */
  cursor?: Uint8Array | undefined;

  /**
   * @generated from field: uint32 limit = 2;
   */
  limit: number;
};

/**
 * Describes the message chat.v1.ListDialogHeadsRequest.
 * Use `create(ListDialogHeadsRequestSchema)` to create a new message.
 */
export const ListDialogHeadsRequestSchema: GenMessage<ListDialogHeadsRequest> = /*@__PURE__*/
  messageDesc(file_chat_v1_methods_p1, 22);

/**
 * @generated from message chat.v1.ListDialogHeadsResponse
 */
export type ListDialogHeadsResponse = Message<"chat.v1.ListDialogHeadsResponse"> & {
  /**
   * @generated from field: repeated chat.v1.Dialog dialogs = 1;
   */
  dialogs: Dialog[];

  /**
   * @generated from field: chat.v1.PageInfo page = 2;
   */
  page?: PageInfo | undefined;
};

/**
 * Describes the message chat.v1.ListDialogHeadsResponse.
 * Use `create(ListDialogHeadsResponseSchema)` to create a new message.
 */
export const ListDialogHeadsResponseSchema: GenMessage<ListDialogHeadsResponse> = /*@__PURE__*/
  messageDesc(file_chat_v1_methods_p1, 23);

/**
 * @generated from message chat.v1.AckDeviceProgressRequest
 */
export type AckDeviceProgressRequest = Message<"chat.v1.AckDeviceProgressRequest"> & {
  /**
   * @generated from field: string stream_id = 1;
   */
  streamId: string;

  /**
   * @generated from field: bytes cursor = 2;
   */
  cursor: Uint8Array;
};

/**
 * Describes the message chat.v1.AckDeviceProgressRequest.
 * Use `create(AckDeviceProgressRequestSchema)` to create a new message.
 */
export const AckDeviceProgressRequestSchema: GenMessage<AckDeviceProgressRequest> = /*@__PURE__*/
  messageDesc(file_chat_v1_methods_p1, 24);

/**
 * @generated from message chat.v1.AckDeviceProgressResponse
 */
export type AckDeviceProgressResponse = Message<"chat.v1.AckDeviceProgressResponse"> & {
  /**
   * @generated from field: int64 accepted_through = 1;
   */
  acceptedThrough: bigint;
};

/**
 * Describes the message chat.v1.AckDeviceProgressResponse.
 * Use `create(AckDeviceProgressResponseSchema)` to create a new message.
 */
export const AckDeviceProgressResponseSchema: GenMessage<AckDeviceProgressResponse> = /*@__PURE__*/
  messageDesc(file_chat_v1_methods_p1, 25);

/**
 * @generated from message chat.v1.MarkReadRequest
 */
export type MarkReadRequest = Message<"chat.v1.MarkReadRequest"> & {
  /**
   * @generated from field: bytes conversation_id = 1;
   */
  conversationId: Uint8Array;

  /**
   * @generated from field: int64 last_read_created_seq = 2;
   */
  lastReadCreatedSeq: bigint;

  /**
   * @generated from field: bytes client_op_id = 3;
   */
  clientOpId: Uint8Array;
};

/**
 * Describes the message chat.v1.MarkReadRequest.
 * Use `create(MarkReadRequestSchema)` to create a new message.
 */
export const MarkReadRequestSchema: GenMessage<MarkReadRequest> = /*@__PURE__*/
  messageDesc(file_chat_v1_methods_p1, 26);

/**
 * @generated from message chat.v1.MarkReadResponse
 */
export type MarkReadResponse = Message<"chat.v1.MarkReadResponse"> & {
  /**
   * @generated from field: chat.v1.Commit commit = 1;
   */
  commit?: Commit | undefined;
};

/**
 * Describes the message chat.v1.MarkReadResponse.
 * Use `create(MarkReadResponseSchema)` to create a new message.
 */
export const MarkReadResponseSchema: GenMessage<MarkReadResponse> = /*@__PURE__*/
  messageDesc(file_chat_v1_methods_p1, 27);

/**
 * @generated from message chat.v1.SubscribeRequest
 */
export type SubscribeRequest = Message<"chat.v1.SubscribeRequest"> & {
  /**
   * @generated from field: bytes conversation_id = 1;
   */
  conversationId: Uint8Array;

  /**
   * @generated from field: optional bytes cursor = 2;
   */
  cursor?: Uint8Array | undefined;
};

/**
 * Describes the message chat.v1.SubscribeRequest.
 * Use `create(SubscribeRequestSchema)` to create a new message.
 */
export const SubscribeRequestSchema: GenMessage<SubscribeRequest> = /*@__PURE__*/
  messageDesc(file_chat_v1_methods_p1, 28);

/**
 * @generated from message chat.v1.SubscribeResponse
 */
export type SubscribeResponse = Message<"chat.v1.SubscribeResponse"> & {
  /**
   * @generated from field: bool accepted = 1;
   */
  accepted: boolean;

  /**
   * @generated from field: int64 head = 2;
   */
  head: bigint;
};

/**
 * Describes the message chat.v1.SubscribeResponse.
 * Use `create(SubscribeResponseSchema)` to create a new message.
 */
export const SubscribeResponseSchema: GenMessage<SubscribeResponse> = /*@__PURE__*/
  messageDesc(file_chat_v1_methods_p1, 29);

/**
 * @generated from message chat.v1.UnsubscribeRequest
 */
export type UnsubscribeRequest = Message<"chat.v1.UnsubscribeRequest"> & {
  /**
   * @generated from field: bytes conversation_id = 1;
   */
  conversationId: Uint8Array;
};

/**
 * Describes the message chat.v1.UnsubscribeRequest.
 * Use `create(UnsubscribeRequestSchema)` to create a new message.
 */
export const UnsubscribeRequestSchema: GenMessage<UnsubscribeRequest> = /*@__PURE__*/
  messageDesc(file_chat_v1_methods_p1, 30);

/**
 * @generated from message chat.v1.UnsubscribeResponse
 */
export type UnsubscribeResponse = Message<"chat.v1.UnsubscribeResponse"> & {
  /**
   * @generated from field: bool accepted = 1;
   */
  accepted: boolean;
};

/**
 * Describes the message chat.v1.UnsubscribeResponse.
 * Use `create(UnsubscribeResponseSchema)` to create a new message.
 */
export const UnsubscribeResponseSchema: GenMessage<UnsubscribeResponse> = /*@__PURE__*/
  messageDesc(file_chat_v1_methods_p1, 31);

/**
 * @generated from message chat.v1.SetTypingRequest
 */
export type SetTypingRequest = Message<"chat.v1.SetTypingRequest"> & {
  /**
   * @generated from field: bytes conversation_id = 1;
   */
  conversationId: Uint8Array;

  /**
   * @generated from field: bool typing = 2;
   */
  typing: boolean;
};

/**
 * Describes the message chat.v1.SetTypingRequest.
 * Use `create(SetTypingRequestSchema)` to create a new message.
 */
export const SetTypingRequestSchema: GenMessage<SetTypingRequest> = /*@__PURE__*/
  messageDesc(file_chat_v1_methods_p1, 32);

/**
 * @generated from message chat.v1.SetTypingResponse
 */
export type SetTypingResponse = Message<"chat.v1.SetTypingResponse"> & {
  /**
   * @generated from field: int64 expires_at = 1;
   */
  expiresAt: bigint;
};

/**
 * Describes the message chat.v1.SetTypingResponse.
 * Use `create(SetTypingResponseSchema)` to create a new message.
 */
export const SetTypingResponseSchema: GenMessage<SetTypingResponse> = /*@__PURE__*/
  messageDesc(file_chat_v1_methods_p1, 33);

/**
 * @generated from message chat.v1.SetBlockRequest
 */
export type SetBlockRequest = Message<"chat.v1.SetBlockRequest"> & {
  /**
   * @generated from field: bytes target_user_id = 1;
   */
  targetUserId: Uint8Array;

  /**
   * @generated from field: bool blocked = 2;
   */
  blocked: boolean;

  /**
   * @generated from field: bytes client_op_id = 3;
   */
  clientOpId: Uint8Array;
};

/**
 * Describes the message chat.v1.SetBlockRequest.
 * Use `create(SetBlockRequestSchema)` to create a new message.
 */
export const SetBlockRequestSchema: GenMessage<SetBlockRequest> = /*@__PURE__*/
  messageDesc(file_chat_v1_methods_p1, 34);

/**
 * @generated from message chat.v1.SetBlockResponse
 */
export type SetBlockResponse = Message<"chat.v1.SetBlockResponse"> & {
  /**
   * @generated from field: chat.v1.Commit commit = 1;
   */
  commit?: Commit | undefined;
};

/**
 * Describes the message chat.v1.SetBlockResponse.
 * Use `create(SetBlockResponseSchema)` to create a new message.
 */
export const SetBlockResponseSchema: GenMessage<SetBlockResponse> = /*@__PURE__*/
  messageDesc(file_chat_v1_methods_p1, 35);

/**
 * @generated from message chat.v1.ReportRequest
 */
export type ReportRequest = Message<"chat.v1.ReportRequest"> & {
  /**
   * @generated from field: bytes conversation_id = 1;
   */
  conversationId: Uint8Array;

  /**
   * @generated from field: repeated bytes message_ids = 2;
   */
  messageIds: Uint8Array[];

  /**
   * @generated from field: string reason = 3;
   */
  reason: string;

  /**
   * @generated from field: string text = 4;
   */
  text: string;

  /**
   * @generated from field: bytes client_op_id = 5;
   */
  clientOpId: Uint8Array;
};

/**
 * Describes the message chat.v1.ReportRequest.
 * Use `create(ReportRequestSchema)` to create a new message.
 */
export const ReportRequestSchema: GenMessage<ReportRequest> = /*@__PURE__*/
  messageDesc(file_chat_v1_methods_p1, 36);

/**
 * @generated from message chat.v1.ReportResponse
 */
export type ReportResponse = Message<"chat.v1.ReportResponse"> & {
  /**
   * @generated from field: bytes report_id = 1;
   */
  reportId: Uint8Array;

  /**
   * @generated from field: chat.v1.Commit commit = 2;
   */
  commit?: Commit | undefined;
};

/**
 * Describes the message chat.v1.ReportResponse.
 * Use `create(ReportResponseSchema)` to create a new message.
 */
export const ReportResponseSchema: GenMessage<ReportResponse> = /*@__PURE__*/
  messageDesc(file_chat_v1_methods_p1, 37);

/**
 * @generated from message chat.v1.ResolveUserRequest
 */
export type ResolveUserRequest = Message<"chat.v1.ResolveUserRequest"> & {
  /**
   * @generated from field: optional string username = 1;
   */
  username?: string | undefined;

  /**
   * @generated from field: optional string phone_e164 = 2;
   */
  phoneE164?: string | undefined;
};

/**
 * Describes the message chat.v1.ResolveUserRequest.
 * Use `create(ResolveUserRequestSchema)` to create a new message.
 */
export const ResolveUserRequestSchema: GenMessage<ResolveUserRequest> = /*@__PURE__*/
  messageDesc(file_chat_v1_methods_p1, 38);

/**
 * @generated from message chat.v1.ResolveUserResponse
 */
export type ResolveUserResponse = Message<"chat.v1.ResolveUserResponse"> & {
  /**
   * @generated from field: bytes user_id = 1;
   */
  userId: Uint8Array;

  /**
   * @generated from field: string display_name = 2;
   */
  displayName: string;

  /**
   * @generated from field: optional string username = 3;
   */
  username?: string | undefined;
};

/**
 * Describes the message chat.v1.ResolveUserResponse.
 * Use `create(ResolveUserResponseSchema)` to create a new message.
 */
export const ResolveUserResponseSchema: GenMessage<ResolveUserResponse> = /*@__PURE__*/
  messageDesc(file_chat_v1_methods_p1, 39);

/**
 * MethodId is the registry. Ranges stay reserved across phases so a later
 * family cannot renumber an earlier one.
 *
 * @generated from enum chat.v1.MethodId
 */
export enum MethodId {
  /**
   * @generated from enum value: METHOD_ID_UNKNOWN = 0;
   */
  UNKNOWN = 0,

  /**
   * @generated from enum value: METHOD_ID_HELLO = 1;
   */
  HELLO = 1,

  /**
   * @generated from enum value: METHOD_ID_AUTH = 2;
   */
  AUTH = 2,

  /**
   * @generated from enum value: METHOD_ID_PING = 3;
   */
  PING = 3,

  /**
   * @generated from enum value: METHOD_ID_CREATE_DIRECT_CONVERSATION = 10;
   */
  CREATE_DIRECT_CONVERSATION = 10,

  /**
   * @generated from enum value: METHOD_ID_SEND_MESSAGE = 11;
   */
  SEND_MESSAGE = 11,

  /**
   * @generated from enum value: METHOD_ID_GET_OPERATION_STATUS = 12;
   */
  GET_OPERATION_STATUS = 12,

  /**
   * @generated from enum value: METHOD_ID_EDIT_MESSAGE = 13;
   */
  EDIT_MESSAGE = 13,

  /**
   * @generated from enum value: METHOD_ID_DELETE_MESSAGE = 14;
   */
  DELETE_MESSAGE = 14,

  /**
   * @generated from enum value: METHOD_ID_GET_HISTORY = 15;
   */
  GET_HISTORY = 15,

  /**
   * @generated from enum value: METHOD_ID_GET_DIFFERENCE = 16;
   */
  GET_DIFFERENCE = 16,

  /**
   * @generated from enum value: METHOD_ID_SYNC_USER = 17;
   */
  SYNC_USER = 17,

  /**
   * @generated from enum value: METHOD_ID_LIST_DIALOG_HEADS = 18;
   */
  LIST_DIALOG_HEADS = 18,

  /**
   * @generated from enum value: METHOD_ID_ACK_DEVICE_PROGRESS = 19;
   */
  ACK_DEVICE_PROGRESS = 19,

  /**
   * @generated from enum value: METHOD_ID_MARK_READ = 20;
   */
  MARK_READ = 20,

  /**
   * @generated from enum value: METHOD_ID_SUBSCRIBE = 21;
   */
  SUBSCRIBE = 21,

  /**
   * @generated from enum value: METHOD_ID_UNSUBSCRIBE = 22;
   */
  UNSUBSCRIBE = 22,

  /**
   * @generated from enum value: METHOD_ID_SET_TYPING = 23;
   */
  SET_TYPING = 23,

  /**
   * @generated from enum value: METHOD_ID_SET_BLOCK = 24;
   */
  SET_BLOCK = 24,

  /**
   * @generated from enum value: METHOD_ID_REPORT = 25;
   */
  REPORT = 25,

  /**
   * @generated from enum value: METHOD_ID_RESOLVE_USER = 26;
   */
  RESOLVE_USER = 26,
}

/**
 * Describes the enum chat.v1.MethodId.
 */
export const MethodIdSchema: GenEnum<MethodId> = /*@__PURE__*/
  enumDesc(file_chat_v1_methods_p1, 0);

